import React from "react";
export default function () {
    return (
        <svg width="200" height="200" viewBox="0 0 200 200">
            <path d="M30.9,60.2,23.5,78.6,19,90h0l-6.4,16H9.5l7.1-16.3,2.9-6.6h0s-5,1.5-7.3,1.4-4.8-.1-6.5-2.4a3.8,3.8,0,0,1,.8-5.3,6.5,6.5,0,0,1,5.9-.8c2.1.9,2.1,4.3.5,6.8,0,0,2.3,1.3,7.6-2.1l7.4-16.3s-6.4,1.9-8.7,1.8-4.8-.1-6.5-2.4a3.8,3.8,0,0,1,.8-5.3,6.5,6.5,0,0,1,5.9-.8c2.1.9,2.1,4.3.5,6.8C19.9,64.7,23.5,66.3,30.9,60.2Z" />
        </svg>
    );
}
